import { css } from 'styled-components'

const TabsStyles = css`
  .rts___tabs___container {
    padding: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    /* left arrow button */
    & > div:first-child > .rts___nav___btn {
      left: 0;
      &:after {
        background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
        left: 20px;
        z-index: 1;
      }
    }

    /* right arrow button */
    & > div:last-child > .rts___nav___btn {
      right: 0;
      &:after {
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
        left: -40px;
      }
    }
  }

  .rts___tabs {
    padding: 0;
  }

  .rts___btn {
    border-radius: unset;
    border: none;
  }

  .rts___tab {
    padding: 0;
    margin: 0;
    position: relative;
  }

  .rts___tab___selected {
    color: #000;
    position: relative;
    width: 100%;
    background: transparent;
    box-shadow: none;
  }

  .rts___nav___btn___container {
    min-width: 16px;
    height: 16px;
    padding: 2px;
    position: relative;
  }

  .rts___nav___btn {
    padding: 2px;
    position: absolute;
    background: transparent;
    width: 16px;
    height: 16px;

    &:hover {
      background-color: unset;
    }

    &:disabled {
      visibility: hidden;
    }

    &:after {
      content: "";
      position: absolute;
      width: 40px;
      top: -4px;
      bottom: -4px;
      pointer-events: none;
    }
  }
`

export default TabsStyles
